export enum MailTemplateDataType
{
	Unknown = 0,
	ContractChangesNotification = 1,
	OnCommentReceived = 2,
	LineManagerStatus = 3,
}
